'use strict';

exports.exists = ('ontouchstart' in document.documentElement);



// WEBPACK FOOTER //
// ./~/jshint-loader!./lib/util/touch.js